import { render, staticRenderFns } from "./TextDiffView.vue?vue&type=template&id=183ba620&scoped=true&"
import script from "./TextDiffView.vue?vue&type=script&lang=js&"
export * from "./TextDiffView.vue?vue&type=script&lang=js&"
import style0 from "./TextDiffView.vue?vue&type=style&index=0&id=183ba620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ba620",
  null
  
)

export default component.exports